import { BackendUnavailable } from '@/shared/ui/backend-unavailable';
import { isBackendUnavailable } from '@/shared/lib/utils/is-backend-unavailable';
import { useRouteError } from 'react-router-dom';
import { ApplicationError } from '.';

export const RouteApplicationError = () => {
  const error = useRouteError();

  return isBackendUnavailable(error) ? (
    <BackendUnavailable initialError={error} />
  ) : (
    <ApplicationError />
  );
};